"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdFormik = require("cccisd-formik");
var _warning = _interopRequireDefault(require("cccisd-icons/warning"));
var _cccisdWysiwyg = _interopRequireDefault(require("cccisd-wysiwyg"));
var _InlineWysiwyg = require("./InlineWysiwyg");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SectionTitle = function SectionTitle(props) {
  var name = props.name,
    placeholder = props.placeholder;
  var fieldName = "courseDescription.".concat(name, ".title");
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: fieldName,
    render: function render(_ref) {
      var field = _ref.field,
        form = _ref.form;
      var isTouched = (0, _get2["default"])(form.touched, fieldName, false);
      var isWarning = isTouched && field.value === '';
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
        field: field,
        form: form,
        label: "Section Title"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], _extends({
        content: field.value || placeholder,
        onBlur: field.onBlur,
        onChange: function onChange(value) {
          form.setFieldTouched(field.name);
          form.setFieldValue(field.name, value);
        },
        settings: {
          toolbar: _InlineWysiwyg.toolbar
        },
        type: "input"
      }, props)), isWarning && /*#__PURE__*/_react["default"].createElement("p", {
        className: 'text-warning ' + _style["default"].sectionTitleWarning
      }, /*#__PURE__*/_react["default"].createElement(_warning["default"], null), " Section Title will default to \"", placeholder, "\""));
    }
  });
};
var _default = SectionTitle;
exports["default"] = _default;